import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { getConsent, setConsent, initConsent } from "@/lib/consent";
import { Link } from "react-router-dom";

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    initConsent();
    if (getConsent() === null) setVisible(true);

    const onReset = () => setVisible(true);
    window.addEventListener("pyl-consent-reset", onReset);
    return () => window.removeEventListener("pyl-consent-reset", onReset);
  }, []);

  if (!visible) return null;

  const handle = (value: "accepted" | "rejected") => {
    setConsent(value);
    setVisible(false);
  };

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie consent"
      className="fixed inset-x-0 bottom-0 z-[100] border-t border-border/60 bg-background/95 backdrop-blur-md"
    >
      <div className="container mx-auto px-4 py-2.5 flex items-center justify-between gap-4">
        <p className="text-xs md:text-[13px] text-foreground/75 leading-snug flex-1 min-w-0">
          We use optional cookies to understand how guests discover the collection.{" "}
          <button
            type="button"
            onClick={() => handle("rejected")}
            className="underline underline-offset-2 hover:text-primary transition-colors"
          >
            Cookie settings
          </button>
        </p>
        <Button
          size="sm"
          onClick={() => handle("accepted")}
          className="h-8 px-5 text-xs uppercase tracking-[0.15em] shrink-0"
        >
          Accept
        </Button>
      </div>
    </div>
  );
}
